import { Topic, AnalyticsEventEmitter } from '../events';
import { getUUID } from '../utils';
export async function messageFactory(topic, partial) {
    let message;
    switch (topic) {
        case Topic.APP_BACKGROUNDED:
            message;
            break;
        case Topic.APP_FOREGROUNDED:
            message;
            break;
        case Topic.APP_SCREEN_VIEWED:
            message;
            break;
        case Topic.APP_AUTHENTICATION_COMPLETED:
            message;
            break;
        case Topic.APP_AUTHENTICATION_FAILED:
            message;
            break;
        case Topic.APP_AUTHENTICATION_STARTED:
            message;
            break;
        case Topic.APP_AUTHENTICATION_SIGNOUT:
            message;
            break;
        case Topic.CONTENT_DOWNLOAD_COMPLETED:
            message;
            break;
        case Topic.CONTENT_DOWNLOAD_DELETED:
            message;
            break;
        case Topic.CONTENT_DOWNLOAD_STARTED:
            message;
            break;
        case Topic.CONTENT_STATUS_COMPLETED:
            message;
            break;
        case Topic.CONTENT_STATUS_UNCOMPLETED:
            message;
            break;
        case Topic.PLAYBACK_PAUSED:
            message;
            break;
        case Topic.PLAYBACK_SEEK:
            message;
            break;
        case Topic.PLAYBACK_STARTED:
            message;
            break;
        case Topic.PLAYBACK_RESUMED:
            message;
            break;
        case Topic.PLAYBACK_STATUS:
            message;
            break;
        case Topic.PURCHASE_COMPLETED:
            message;
            break;
        case Topic.PURCHASE_PRODUCT_SELECTED:
            message;
            break;
        case Topic.PURCHASE_STARTED:
            message;
            break;
        case Topic.SYNC_PROGRESS:
            message = { topic };
            break;
        default:
            throw new Error(`Attempted to send an invalid message: '${topic}'`);
    }
    const userId = await getUUID();
    const timestamp = (new Date()).toISOString();
    if (!message) {
        message = {
            topic,
            payload: {
                ...partial,
                userId,
                timestamp,
            },
        };
    }
    await AnalyticsEventEmitter.emit(message.topic, message);
    return;
}
//# sourceMappingURL=messageFactory.js.map